export default {
  namespaced: true,
  state: {
    level: parseInt(localStorage.getItem('global_brightness')) || 100
  },
  mutations: {
    SET_LEVEL(state, payload) {
      state.level = payload;
      localStorage.setItem('global_brightness', payload);
    }
  },
  actions: {
    updateBrightness({ commit }, value) {
      commit('SET_LEVEL', value);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/brightness.js